export const USER_HAS_SEEN_THE_OPENAI_TERMS = 'userHasSeenTheOpenAITerms';
